/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(2);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _FsgoItems = __webpack_require__(3);
	
	var _FsgoItems2 = _interopRequireDefault(_FsgoItems);
	
	var _EsiGeo = __webpack_require__(6);
	
	var _EsiGeo2 = _interopRequireDefault(_EsiGeo);
	
	var _FsgoVideosService = __webpack_require__(7);
	
	var _FsgoVideosService2 = _interopRequireDefault(_FsgoVideosService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Fsgo = function (_React$Component) {
		_inherits(Fsgo, _React$Component);
	
		function Fsgo(props) {
			_classCallCheck(this, Fsgo);
	
			var _this = _possibleConstructorReturn(this, (Fsgo.__proto__ || Object.getPrototypeOf(Fsgo)).call(this, props));
	
			_this.state = {
				isDataFetched: false,
				title: props.title,
				limit: props.limit,
				postType: props.postType
			};
			return _this;
		}
	
		_createClass(Fsgo, [{
			key: 'componentWillMount',
			value: function componentWillMount() {
				performance.mark('fsgo[' + this.props.componentId + ']-componentWillMount');
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate() {
				performance.mark('fsgo[' + this.props.componentId + ']-componentDidUpdate');
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				var _this2 = this;
	
				performance.mark('fsgo[' + this.props.componentId + ']-componentDidMount');
				performance.mark('fsgo[' + this.props.componentId + ']-getVideos');
	
				_FsgoVideosService2.default.getVideos(_EsiGeo2.default.zip, this.props.limit).then(function (videos) {
					performance.mark('fsgo[' + _this2.props.componentId + ']-setState');
					_this2.setState(function () {
						return {
							isDataFetched: true,
							liveVideos: videos.liveVideos,
							upcomingVideos: videos.upcomingVideos,
							featureVideos: videos.featureVideos
						};
					});
				});
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					null,
					this.state.isDataFetched && _react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(
							'h3',
							{ className: 'sidebar-component-title' },
							this.state.title
						),
						this.state.postType !== 'fox_sectionfront' && _react2.default.createElement('span', { className: 'separator' }),
						_react2.default.createElement(
							'div',
							{ className: 'fs-go-sidebar-container' },
							_react2.default.createElement(
								'ul',
								{ className: 'tune-in-list' },
								this.state.liveVideos.length > 0 && _react2.default.createElement(_FsgoItems2.default, { items: this.state.liveVideos, state: 'live', title: 'LIVE NOW' }),
								this.state.featureVideos.length > 0 && _react2.default.createElement(_FsgoItems2.default, { items: this.state.featureVideos, state: 'featured', title: 'FEATURED' }),
								this.state.upcomingVideos.length > 0 && _react2.default.createElement(_FsgoItems2.default, { items: this.state.upcomingVideos, state: 'upcoming', title: 'UPCOMING' })
							)
						)
					)
				);
			}
		}]);
	
		return Fsgo;
	}(_react2.default.Component);
	
	var renderFsgo = function renderFsgo(id) {
		var mountNode = document.getElementById(id);
	
		if (mountNode) {
			performance.mark('fsgo[0]-render-start');
			var title = mountNode.getAttribute('title');
			var limit = mountNode.getAttribute('limit');
			var postType = mountNode.getAttribute('post-type');
			_reactDom2.default.render(_react2.default.createElement(Fsgo, { title: title, limit: limit, postType: postType, componentId: 0 }), mountNode);
		}
	};
	
	var mountNodes = document.getElementsByTagName('Fsgo');
	
	if (mountNodes) {
		for (var i = 0; i < mountNodes.length; i++) {
			var mountNode = mountNodes[i];
			renderFsgo(mountNode.getAttribute('id'));
		}
	}
	
	window.renderFsgo = renderFsgo;

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	module.exports = React;

/***/ }),
/* 2 */
/***/ (function(module, exports) {

	module.exports = ReactDOM;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FsgoItem = __webpack_require__(4);
	
	var _FsgoItem2 = _interopRequireDefault(_FsgoItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FsgoItems = function (_React$Component) {
		_inherits(FsgoItems, _React$Component);
	
		function FsgoItems(props) {
			_classCallCheck(this, FsgoItems);
	
			return _possibleConstructorReturn(this, (FsgoItems.__proto__ || Object.getPrototypeOf(FsgoItems)).call(this, props));
		}
	
		_createClass(FsgoItems, [{
			key: 'render',
			value: function render() {
				var title = this.props.title;
				var state = this.props.state;
				var videos = this.props.items;
				var idx = 1;
	
				return _react2.default.createElement(
					'li',
					{ className: 'tune-in-item' },
					_react2.default.createElement(
						'div',
						{ className: 'tune-in-item-container' },
						_react2.default.createElement(
							'div',
							{ className: 'live' },
							_react2.default.createElement(
								'div',
								{ className: 'title' },
								title
							),
							_react2.default.createElement('span', { className: 'separator' }),
							_react2.default.createElement(
								'div',
								{ className: 'content' },
								_react2.default.createElement(
									'ul',
									{ className: 'videos' },
									videos.map(function (v) {
										return _react2.default.createElement(_FsgoItem2.default, { item: v, state: state, idx: idx++ });
									})
								)
							)
						)
					)
				);
			}
		}]);
	
		return FsgoItems;
	}(_react2.default.Component);
	
	exports.default = FsgoItems;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _constants = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FsgoItem = function (_React$Component) {
		_inherits(FsgoItem, _React$Component);
	
		function FsgoItem(props) {
			_classCallCheck(this, FsgoItem);
	
			return _possibleConstructorReturn(this, (FsgoItem.__proto__ || Object.getPrototypeOf(FsgoItem)).call(this, props));
		}
	
		_createClass(FsgoItem, [{
			key: 'render',
			value: function render() {
				var state = this.props.state;
				var idx = this.props.idx;
				var isLive = state === 'live';
				var v = this.props.item;
				var isMobileStreamingAllowed = v.tag !== _constants.settings.notAllowedMobileStreamingTag;
	
				return _react2.default.createElement(
					'li',
					{ className: 'video-list ' + state },
					_react2.default.createElement(
						'a',
						{ href: v.url,
							id: 'tune-in-video-' + state + '-' + idx,
							target: '_blank',
							className: 'video-link ' + (!isMobileStreamingAllowed ? 'disable-link' : '') },
						_react2.default.createElement(
							'figure',
							{ className: 'video-thumbnail' },
							_react2.default.createElement(
								'div',
								{ className: 'img-wrap' },
								_react2.default.createElement('img', { className: 'video-img', src: v.resizedImageUrl }),
								isLive && _react2.default.createElement('span', { className: 'fs-icons_video' })
							),
							_react2.default.createElement(
								'div',
								{ className: 'channel-container ' + (v.channelDescription || '').toLowerCase() },
								_react2.default.createElement(
									'div',
									{ className: 'channel-desc' },
									v.channelDescription
								)
							),
							!isMobileStreamingAllowed && _react2.default.createElement(
								'div',
								{ className: 'availability-alert' },
								_react2.default.createElement(
									'div',
									{ className: 'alert-title' },
									'Available on'
								),
								_react2.default.createElement(
									'div',
									{ className: 'alert-devices' },
									'Tablet, Computer & Connected Devices'
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'video-desc' },
							isLive ? _react2.default.createElement(
								'div',
								{ className: 'live-time-wrapper' },
								_react2.default.createElement('span', { className: 'state' }),
								_react2.default.createElement(
									'span',
									{ className: 'start-time' },
									v.formattedStartTime
								)
							) : _react2.default.createElement(
								'span',
								{ className: 'state' },
								v.formattedStartTime
							),
							_react2.default.createElement(
								'span',
								{ className: 'desc' },
								v.title
							),
							v.isReplay && _react2.default.createElement(
								'span',
								{ className: 'replay' },
								' REPLAY '
							)
						)
					)
				);
			}
		}]);
	
		return FsgoItem;
	}(_react2.default.Component);
	
	exports.default = FsgoItem;

/***/ }),
/* 5 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var settings = exports.settings = {
		progsUrl: '/wp-json/fsgo/prog',
		notAllowedMobileStreamingTag: 'NFL'
	};

/***/ }),
/* 6 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var EsiGeo = function () {
		function EsiGeo() {
			_classCallCheck(this, EsiGeo);
	
			var zip = this.getValueById('esi_geo_zip');
			this.zip = zip ? zip.substring(0, 5) : null;
		}
	
		_createClass(EsiGeo, [{
			key: 'getValueById',
			value: function getValueById(id) {
				var element = document.getElementById(id);
	
				if (!element || !element.innerHTML || element.innerHTML[0] === '$') return null;
	
				return element.innerHTML;
			}
		}]);
	
		return EsiGeo;
	}();
	
	exports.default = new EsiGeo();

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _isomorphicFetch = __webpack_require__(8);
	
	var _isomorphicFetch2 = _interopRequireDefault(_isomorphicFetch);
	
	var _constants = __webpack_require__(10);
	
	var _constants2 = __webpack_require__(5);
	
	var _utils = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Videos = function Videos() {
		_classCallCheck(this, Videos);
	
		this.liveVideos = [];
		this.upcomingVideos = [];
		this.featureVideos = [];
	};
	
	var FsgoVideosServices = function () {
		function FsgoVideosServices() {
			_classCallCheck(this, FsgoVideosServices);
	
			this.getVideosProm = null;
		}
	
		_createClass(FsgoVideosServices, [{
			key: 'getVideos',
			value: function getVideos(zip, limit) {
				if (this.getVideosProm) {
					return this.getVideosProm;
				}
	
				var options = Object.assign({ method: 'GET' }, _constants.headers);
	
				this.getVideosProm = (0, _isomorphicFetch2.default)(_constants2.settings.progsUrl + '?zip=' + (zip || '') + '&limit=' + (limit || ''), options).then(_utils.handleFetchedErrors).then(function (response) {
					return response.json();
				}).then(function (json) {
					var result = new Videos();
	
					result.liveVideos = getItemsFromProg(json.live);
					result.featureVideos = getItemsFromProg(json.featured);
					result.upcomingVideos = getItemsFromProg(json.upcoming);
	
					return result;
				}).catch(function () {
					return new Videos();
				});
	
				return this.getVideosProm;
			}
		}]);
	
		return FsgoVideosServices;
	}();
	
	function getItemsFromProg(prog) {
		if (prog && prog.count > 0) {
			return prog.items || [];
		}
	
		return [];
	}
	
	exports.default = new FsgoVideosServices();

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	// the whatwg-fetch polyfill installs the fetch() function
	// on the global object (window or self)
	//
	// Return that as the export for use in Webpack, Browserify etc.
	__webpack_require__(9);
	module.exports = self.fetch.bind(self);


/***/ }),
/* 9 */
/***/ (function(module, exports) {

	(function(self) {
	  'use strict';
	
	  if (self.fetch) {
	    return
	  }
	
	  var support = {
	    searchParams: 'URLSearchParams' in self,
	    iterable: 'Symbol' in self && 'iterator' in Symbol,
	    blob: 'FileReader' in self && 'Blob' in self && (function() {
	      try {
	        new Blob()
	        return true
	      } catch(e) {
	        return false
	      }
	    })(),
	    formData: 'FormData' in self,
	    arrayBuffer: 'ArrayBuffer' in self
	  }
	
	  if (support.arrayBuffer) {
	    var viewClasses = [
	      '[object Int8Array]',
	      '[object Uint8Array]',
	      '[object Uint8ClampedArray]',
	      '[object Int16Array]',
	      '[object Uint16Array]',
	      '[object Int32Array]',
	      '[object Uint32Array]',
	      '[object Float32Array]',
	      '[object Float64Array]'
	    ]
	
	    var isDataView = function(obj) {
	      return obj && DataView.prototype.isPrototypeOf(obj)
	    }
	
	    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
	      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
	    }
	  }
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name)
	    }
	    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
	      throw new TypeError('Invalid character in header field name')
	    }
	    return name.toLowerCase()
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value)
	    }
	    return value
	  }
	
	  // Build a destructive iterator for the value list
	  function iteratorFor(items) {
	    var iterator = {
	      next: function() {
	        var value = items.shift()
	        return {done: value === undefined, value: value}
	      }
	    }
	
	    if (support.iterable) {
	      iterator[Symbol.iterator] = function() {
	        return iterator
	      }
	    }
	
	    return iterator
	  }
	
	  function Headers(headers) {
	    this.map = {}
	
	    if (headers instanceof Headers) {
	      headers.forEach(function(value, name) {
	        this.append(name, value)
	      }, this)
	    } else if (Array.isArray(headers)) {
	      headers.forEach(function(header) {
	        this.append(header[0], header[1])
	      }, this)
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function(name) {
	        this.append(name, headers[name])
	      }, this)
	    }
	  }
	
	  Headers.prototype.append = function(name, value) {
	    name = normalizeName(name)
	    value = normalizeValue(value)
	    var oldValue = this.map[name]
	    this.map[name] = oldValue ? oldValue+','+value : value
	  }
	
	  Headers.prototype['delete'] = function(name) {
	    delete this.map[normalizeName(name)]
	  }
	
	  Headers.prototype.get = function(name) {
	    name = normalizeName(name)
	    return this.has(name) ? this.map[name] : null
	  }
	
	  Headers.prototype.has = function(name) {
	    return this.map.hasOwnProperty(normalizeName(name))
	  }
	
	  Headers.prototype.set = function(name, value) {
	    this.map[normalizeName(name)] = normalizeValue(value)
	  }
	
	  Headers.prototype.forEach = function(callback, thisArg) {
	    for (var name in this.map) {
	      if (this.map.hasOwnProperty(name)) {
	        callback.call(thisArg, this.map[name], name, this)
	      }
	    }
	  }
	
	  Headers.prototype.keys = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push(name) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.values = function() {
	    var items = []
	    this.forEach(function(value) { items.push(value) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.entries = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push([name, value]) })
	    return iteratorFor(items)
	  }
	
	  if (support.iterable) {
	    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
	  }
	
	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'))
	    }
	    body.bodyUsed = true
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function(resolve, reject) {
	      reader.onload = function() {
	        resolve(reader.result)
	      }
	      reader.onerror = function() {
	        reject(reader.error)
	      }
	    })
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsArrayBuffer(blob)
	    return promise
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsText(blob)
	    return promise
	  }
	
	  function readArrayBufferAsText(buf) {
	    var view = new Uint8Array(buf)
	    var chars = new Array(view.length)
	
	    for (var i = 0; i < view.length; i++) {
	      chars[i] = String.fromCharCode(view[i])
	    }
	    return chars.join('')
	  }
	
	  function bufferClone(buf) {
	    if (buf.slice) {
	      return buf.slice(0)
	    } else {
	      var view = new Uint8Array(buf.byteLength)
	      view.set(new Uint8Array(buf))
	      return view.buffer
	    }
	  }
	
	  function Body() {
	    this.bodyUsed = false
	
	    this._initBody = function(body) {
	      this._bodyInit = body
	      if (!body) {
	        this._bodyText = ''
	      } else if (typeof body === 'string') {
	        this._bodyText = body
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body
	      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	        this._bodyText = body.toString()
	      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
	        this._bodyArrayBuffer = bufferClone(body.buffer)
	        // IE 10-11 can't handle a DataView body.
	        this._bodyInit = new Blob([this._bodyArrayBuffer])
	      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
	        this._bodyArrayBuffer = bufferClone(body)
	      } else {
	        throw new Error('unsupported BodyInit type')
	      }
	
	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8')
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type)
	        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
	        }
	      }
	    }
	
	    if (support.blob) {
	      this.blob = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob)
	        } else if (this._bodyArrayBuffer) {
	          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob')
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]))
	        }
	      }
	
	      this.arrayBuffer = function() {
	        if (this._bodyArrayBuffer) {
	          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
	        } else {
	          return this.blob().then(readBlobAsArrayBuffer)
	        }
	      }
	    }
	
	    this.text = function() {
	      var rejected = consumed(this)
	      if (rejected) {
	        return rejected
	      }
	
	      if (this._bodyBlob) {
	        return readBlobAsText(this._bodyBlob)
	      } else if (this._bodyArrayBuffer) {
	        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
	      } else if (this._bodyFormData) {
	        throw new Error('could not read FormData body as text')
	      } else {
	        return Promise.resolve(this._bodyText)
	      }
	    }
	
	    if (support.formData) {
	      this.formData = function() {
	        return this.text().then(decode)
	      }
	    }
	
	    this.json = function() {
	      return this.text().then(JSON.parse)
	    }
	
	    return this
	  }
	
	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase()
	    return (methods.indexOf(upcased) > -1) ? upcased : method
	  }
	
	  function Request(input, options) {
	    options = options || {}
	    var body = options.body
	
	    if (input instanceof Request) {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read')
	      }
	      this.url = input.url
	      this.credentials = input.credentials
	      if (!options.headers) {
	        this.headers = new Headers(input.headers)
	      }
	      this.method = input.method
	      this.mode = input.mode
	      if (!body && input._bodyInit != null) {
	        body = input._bodyInit
	        input.bodyUsed = true
	      }
	    } else {
	      this.url = String(input)
	    }
	
	    this.credentials = options.credentials || this.credentials || 'omit'
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers)
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET')
	    this.mode = options.mode || this.mode || null
	    this.referrer = null
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests')
	    }
	    this._initBody(body)
	  }
	
	  Request.prototype.clone = function() {
	    return new Request(this, { body: this._bodyInit })
	  }
	
	  function decode(body) {
	    var form = new FormData()
	    body.trim().split('&').forEach(function(bytes) {
	      if (bytes) {
	        var split = bytes.split('=')
	        var name = split.shift().replace(/\+/g, ' ')
	        var value = split.join('=').replace(/\+/g, ' ')
	        form.append(decodeURIComponent(name), decodeURIComponent(value))
	      }
	    })
	    return form
	  }
	
	  function parseHeaders(rawHeaders) {
	    var headers = new Headers()
	    rawHeaders.split(/\r?\n/).forEach(function(line) {
	      var parts = line.split(':')
	      var key = parts.shift().trim()
	      if (key) {
	        var value = parts.join(':').trim()
	        headers.append(key, value)
	      }
	    })
	    return headers
	  }
	
	  Body.call(Request.prototype)
	
	  function Response(bodyInit, options) {
	    if (!options) {
	      options = {}
	    }
	
	    this.type = 'default'
	    this.status = 'status' in options ? options.status : 200
	    this.ok = this.status >= 200 && this.status < 300
	    this.statusText = 'statusText' in options ? options.statusText : 'OK'
	    this.headers = new Headers(options.headers)
	    this.url = options.url || ''
	    this._initBody(bodyInit)
	  }
	
	  Body.call(Response.prototype)
	
	  Response.prototype.clone = function() {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    })
	  }
	
	  Response.error = function() {
	    var response = new Response(null, {status: 0, statusText: ''})
	    response.type = 'error'
	    return response
	  }
	
	  var redirectStatuses = [301, 302, 303, 307, 308]
	
	  Response.redirect = function(url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code')
	    }
	
	    return new Response(null, {status: status, headers: {location: url}})
	  }
	
	  self.Headers = Headers
	  self.Request = Request
	  self.Response = Response
	
	  self.fetch = function(input, init) {
	    return new Promise(function(resolve, reject) {
	      var request = new Request(input, init)
	      var xhr = new XMLHttpRequest()
	
	      xhr.onload = function() {
	        var options = {
	          status: xhr.status,
	          statusText: xhr.statusText,
	          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
	        }
	        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
	        var body = 'response' in xhr ? xhr.response : xhr.responseText
	        resolve(new Response(body, options))
	      }
	
	      xhr.onerror = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.ontimeout = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.open(request.method, request.url, true)
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true
	      }
	
	      if ('responseType' in xhr && support.blob) {
	        xhr.responseType = 'blob'
	      }
	
	      request.headers.forEach(function(value, name) {
	        xhr.setRequestHeader(name, value)
	      })
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
	    })
	  }
	  self.fetch.polyfill = true
	})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 10 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var headers = exports.headers = {
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json'
		},
		credentials: 'include'
	};

/***/ }),
/* 11 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.handleFetchedErrors = handleFetchedErrors;
	function handleFetchedErrors(response) {
		if (!response.ok) {
			throw Error(response.statusText);
		}
	
		return response;
	}

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// assets/dist/js/react/fsgo.min.js